import React from "react";
import { Typography, Box, Grid, Container, Stack, Card, Paper, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import FractalComponent from "./FractalComponent";
import "./FractalApp.css";

class FractalApp extends React.Component {
	
  constructor(props) {
    super(props);
    this.state = {
      juliaConstant: { r: -0.14, i: 0.65 },
	  processing: false,
	  
	};
	this.handleSharedStateChange = this.handleSharedStateChange.bind(this);
  }
 
  handleSharedStateChange(stateObj) {
	  this.setState(stateObj);
  }
  
  render() {
	var canvasSize=Math.floor((window.innerWidth-426)/2);
	var colourOptions={
		cycle: 6,
		redOffset: 0,
		greenOffset: 4,
		blueOffset: 2,
		exponent: 4		
	}
    return (
	<Container maxWidth="100%">
	<Stack spacing={1}>
		<Stack direction="row" spacing={2}>
		  <FractalComponent
			title="Mandelbrot Set"
			fractalType="mandelbrot"
			iterations={100}
			centre={{ r: -0.75, i: 0 }}
			scale={1.6}
			canvasDimensions={{width:canvasSize, height:canvasSize}}
			colourOptions={colourOptions}
			processing={this.state.processing}
			onSharedStateChange={this.handleSharedStateChange}
			workerCount={4}
		  />
		  <FractalComponent
			title="Julia Set"
			fractalType="julia"
			iterations={200}
			centre={{ r: 0, i: 0 }}
			scale={1.6}
			canvasDimensions={{width:canvasSize, height:canvasSize}}
			colourOptions={colourOptions}
			juliaConstant={this.state.juliaConstant}
			processing={this.state.processing}
			onSharedStateChange={this.handleSharedStateChange}
			workerCount={4}
		  />
		</Stack>
		<Divider/>
		<Container maxWidth="100%">
			<Typography variant="h6" align="center">
				Click to centre, click and drag to zoom, control click to zoom out. Shift click on the Mandelbrot set to set the constant for the Julia set
			</Typography>
			<Typography variant="h6" align="center">
				<Link to="/about">Learn More</Link>
			</Typography>
		</Container>
	</Stack>
	</Container>
    );
  }
}

export default FractalApp;